import wLogoClean from '../../assets/w_logo_clean.svg'
import wLogoDark from '../../assets/w_logo_dark.svg'

export default function PageLoader() {
  return (
    <div className="flex min-h-[calc(100vh-120px)] flex-col items-center justify-center gap-8">
      {/* W mark — pulses gently */}
      <div className="relative flex items-center justify-center">
        {/* Outer fading ring */}
        <div className="absolute h-40 w-40 animate-ping rounded-full border border-line opacity-20" />
        {/* Inner subtle ring */}
        <div className="absolute h-28 w-28 rounded-full border border-line opacity-30" />
        {/* Logo */}
        <img
          src={wLogoClean}
          alt=""
          aria-hidden="true"
          className="relative h-20 w-auto animate-pulse dark:hidden"
        />
        <img
          src={wLogoDark}
          alt=""
          aria-hidden="true"
          className="relative hidden h-20 w-auto animate-pulse dark:block"
        />
      </div>

      {/* Label */}
      <div className="flex flex-col items-center gap-1">
        <span className="font-sans text-[10px] font-semibold uppercase tracking-[0.3em] text-fg-secondary">
          Loading
        </span>
        {/* Animated dots */}
        <div className="flex gap-1.5 pt-1">
          <span className="h-1 w-1 animate-bounce rounded-full bg-fg-secondary opacity-50 [animation-delay:0ms]" />
          <span className="h-1 w-1 animate-bounce rounded-full bg-fg-secondary opacity-50 [animation-delay:150ms]" />
          <span className="h-1 w-1 animate-bounce rounded-full bg-fg-secondary opacity-50 [animation-delay:300ms]" />
        </div>
      </div>
    </div>
  )
}
